import React, { useState } from "react";
import Container from "../components/misc/Container";
import LayoutHomepage from "../layout/LayoutHomepage";
import FlashBrokoli from "../assets/images/brokoli-big.png";
import Brokoli from "../assets/images/brokoli.png";
import JagungManis from "../assets/images/sayur/buah/jagung.jpeg";
import Kentank from "../assets/images/sayur/umbi/kentang.jpeg";
import Bayam from "../assets/images/sayur/daun/bayam.jpeg";
import Selada from "../assets/images/sayur/daun/selada.jpeg";
import Terong from "../assets/images/sayur/buah/terong-ungu.jpeg";
import PaprikaMerah from "../assets/images/sayur/buah/paprika-merah.jpeg";
import FlashSaleCircle from "../assets/icons/flashsale-circle.svg";
import TrashIco from "../assets/icons/icon-feather-trash.svg";
import DynamicScrollToTop from "../components/misc/DynamicScrollToTop";
import { Link } from "react-router-dom";

const FLashDealDetail = () => {
  const [showQty, setShowQty] = useState(false);
  const [count, setCount] = useState(0);

  let relatedProductList = [
    {
      imgSrc: Brokoli,
      productName: "Brokoli",
      weight: "250g",
      price: "Rp2500",
      discountPrice: "Rp2000",
      path: "/category",
    },
    {
      imgSrc: JagungManis,
      productName: "Jagung Manis",
      weight: "250g",
      price: "Rp6000",
      discountPrice: "Rp5500",
      path: "/category",
    },
    {
      imgSrc: Kentank,
      productName: "Kentang",
      weight: "250g",
      price: "Rp6000",
      discountPrice: "Rp5500",
      path: "/category",
    },
    {
      imgSrc: Bayam,
      productName: "Bayam",
      weight: "1 ikat",
      price: "RP2000",
      discountPrice: "Rp2000",
      path: "/category",
    },
    {
      imgSrc: Selada,
      productName: "Selada",
      weight: "1 ikat",
      price: "RP2000",
      discountPrice: "Rp2000",
      path: "/category",
    },
    {
      imgSrc: Terong,
      productName: "Terong",
      weight: "250g",
      price: "RP2000",
      discountPrice: "Rp2000",
      path: "/category",
    },
    {
      imgSrc: PaprikaMerah,
      productName: "Paprika Merah",
      weight: "250g",
      price: "RP2000",
      discountPrice: "Rp10000",
      path: "/category",
    },
  ];

  return (
    <>
      <DynamicScrollToTop />
      <LayoutHomepage>
        <div className="flex flex-col w-full mt-32">
          <Container>
            <div className="flex flex-col w-full mr-2">
              <div className="flex w-full mt-8 mb-2">
                <Link to="/homepage">
                  <p className="flex items-center text-font-gray opacity-50">
                    Beranda{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-3 h-3 opacity-100 mx-2"
                      viewBox="0 0 11.384 20.025"
                    >
                      <g
                        id="Group_4034"
                        data-name="Group 4034"
                        transform="translate(1.414 1.414)"
                      >
                        <line
                          id="Line_452"
                          data-name="Line 452"
                          x2="12.099"
                          transform="translate(8.555 8.642) rotate(135)"
                          fill="none"
                          stroke="#596375"
                          strokeLinecap="round"
                          strokeWidth="2"
                        />
                        <line
                          id="Line_453"
                          data-name="Line 453"
                          x2="12.099"
                          transform="translate(8.555 8.555) rotate(-135)"
                          fill="none"
                          stroke="#596375"
                          strokeLinecap="round"
                          strokeWidth="2"
                        />
                      </g>
                    </svg>
                  </p>
                </Link>
                <h1 className="text-font-gray">Produk Terkait</h1>
              </div>
              <div className="py-4 rounded ">
                <div className="flex bg-white w-full py-6 px-12">
                  <div className="flex flex-col w-5/12 p-4">
                    <div className="flex w-full">
                      <div className="relative w-full max-h-70">
                        <img
                          src={FlashBrokoli}
                          className="w-full h-auto"
                          alt=""
                        />
                        <button className="absolute bottom-0 right-0 rounded-full bg-gray-200 p-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            viewBox="0 0 22.267 20.43"
                          >
                            <path
                              id="Icon_material-favorite-border"
                              data-name="Icon material-favorite-border"
                              d="M19.143,4.5a6.667,6.667,0,0,0-5.01,2.327A6.667,6.667,0,0,0,9.123,4.5,6.064,6.064,0,0,0,3,10.623c0,4.208,3.785,7.637,9.519,12.848l1.614,1.458,1.614-1.47c5.734-5.2,9.519-8.628,9.519-12.837A6.064,6.064,0,0,0,19.143,4.5Zm-4.9,17.312-.111.111-.111-.111c-5.3-4.8-8.8-7.971-8.8-11.189a3.805,3.805,0,0,1,3.9-3.9A4.353,4.353,0,0,1,13.1,9.354H15.18a4.325,4.325,0,0,1,3.963-2.627,3.805,3.805,0,0,1,3.9,3.9C23.04,13.841,19.544,17.014,14.245,21.812Z"
                              transform="translate(-3 -4.5)"
                              fill="#596375"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className="flex flex-wrap mt-6">
                      <div className="w-3/12 px-2">
                        <div className="border-2 border-basic-orange px-2 h-20 flex items-center justify-center rounded-lg">
                          <img src={Brokoli} className="w-full h-auto" alt="" />
                        </div>
                      </div>
                      <div className="w-3/12 px-2">
                        <div className="border-2 border-gray-300 hover:border-basic-orange px-2 h-20 flex items-center justify-center rounded-lg">
                          <img src={Brokoli} className="w-full h-auto" alt="" />
                        </div>
                      </div>
                      <div className="w-3/12 px-2">
                        <div className="border-2 border-gray-300 hover:border-basic-orange px-2 h-20 flex items-center justify-center rounded-lg">
                          <img src={Brokoli} className="w-full h-auto" alt="" />
                        </div>
                      </div>
                      <div className="w-3/12 px-2">
                        <div className="border-2 border-gray-300 hover:border-basic-orange px-2 h-20 flex items-center justify-center rounded-lg">
                          <img src={Brokoli} className="w-full h-auto" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-start items-start flex-col w-8/12 pl-6">
                    <h1 className="text-3xl font-semibold text-font-gray mb-2">
                      Brokoli
                    </h1>
                    <div className="flex w-full">
                      <div className="flex w-7/12 bg-basic-orange py-3 px-6 rounded-l-lg">
                        <img src={FlashSaleCircle} className="w-12" alt="" />

                        <div className="flex flex-col w-full px-4">
                          <h5 className="text-white text-lg font-semibold">
                            Flash Deal
                          </h5>
                          <div className="w-full flex items-center">
                            {" "}
                            <span className="rounded  h-1 w-2/12 bg-white"></span>{" "}
                            <p className="text-white ml-2 text-sm">
                              12 Tersisa
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col w-4/12 bg-orange-200 py-3 px-6 rounded-r-lg text-center">
                        <p className="text-basic-orange">BERAKHIR DALAM</p>
                        <p className="text-basic-orange font-semibold">
                          08:06:00
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center my-4">
                      <p className="text-font-gray font-semibold text-xl mr-2">
                        Rp.126.500
                      </p>
                      <p className="text-font-gray mr-4">/250g</p>
                      <p className="text-font-gray opacity-75 line-through">
                        Rp.150.000
                      </p>
                    </div>
                    <div className="flex items-center justify-center border border-basic-orange rounded py-2 px-4">
                      <p className="text-basic-orange mx-2">Hemat</p>
                      <p className="text-basic-orange font-semibold mx-2">
                        23.500
                      </p>
                    </div>
                    {showQty ? (
                      <div className="flex border border-gray-100 rounded-l-lg rounded-r-lg w-full mt-auto">
                        <button
                          className="bg-gray-100 rounded p-1 mr-2"
                          onClick={() => setShowQty(!showQty)}
                        >
                          <img className="px-3" src={TrashIco} alt="" />
                        </button>
                        <input
                          type="number"
                          className="bg-basic-orange text-white text-center capitalize px-4 w-32 rounded-l"
                          value={count}
                        />
                        <button
                          onClick={() => setCount(count + 1)}
                          className="bg-basic-orange text-white capitalize py-3 px-8 w-8 mt-auto rounded-r"
                        >
                          {" "}
                          +{" "}
                        </button>
                      </div>
                    ) : (
                      <button
                        onClick={() => setShowQty(!showQty)}
                        className="bg-basic-orange text-white capitalize py-3 px-12 w-48 mt-auto rounded-lg"
                      >
                        {" "}
                        Beli
                      </button>
                    )}
                  </div>
                </div>
                <div className="flex bg-white w-full mt-4">
                  <div className="flex-wrap">
                    <div className="w-full p-10">
                      <h1>Keterangan</h1>
                      <p>
                      Mengandung Vit B yg sangat menyehatkan dan
masih banyak kandungan didalamnya
                      </p>
                    </div>
                  </div>
                </div>
                {/* Flash Sale */}
                {/* Chat Item */}
                <div className="absolute right-0 top-50"></div>
                {/* Chat ItemEnd  */}
                <div className="bg-white py-4 rounded my-4">
                  <div className="flex px-8 border-b border-gray-300 pb-4">
                    <div className="flex items-center">
                      <h5 className="text-lg text-font-gray tracking-0-22 mr-4">
                        Produk Terkait
                      </h5>
                      <p className="text-sm text-basic-orange italic flex items-center font-semibold">
                        {" "}
                      </p>
                    </div>

                    <button className="flex items-center ml-auto text-basic-orange px-4 py-2">
                      <Link to="/category">Lihat Semua </Link>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 ml-2"
                        viewBox="0 0 13.74 23.333"
                      >
                        <g
                          id="Group_3986"
                          data-name="Group 3986"
                          transform="translate(2.121 2.121)"
                        >
                          <line
                            id="Line_452"
                            data-name="Line 452"
                            x2="13.431"
                            transform="translate(9.497 9.593) rotate(135)"
                            fill="none"
                            stroke="#f86542"
                            strokeLinecap="round"
                            strokeWidth="3"
                          />
                          <line
                            id="Line_453"
                            data-name="Line 453"
                            x2="13.431"
                            transform="translate(9.497 9.497) rotate(-135)"
                            fill="none"
                            stroke="#f86542"
                            strokeLinecap="round"
                            strokeWidth="3"
                          />
                        </g>
                      </svg>
                    </button>
                  </div>
                  {/* Relate product segment */}

                  <div className="flex flex-wrap w-full mx-2">
                    {/* Items  */}
                    {relatedProductList.map((item, index) => (
                      <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                        <div className="flex flex-col px-3 pb-2">
                          <Link to={item.path}>
                            <img
                              src={item.imgSrc}
                              alt="Brokoli"
                              className="h-32"
                            />
                          </Link>
                          <div className="flex flex-col mb-2">
                            <p className="text-font-gray ">
                              {item.productName}
                            </p>
                            <p className="text-font-gray-text text-xs">
                              {item.weight}
                            </p>
                          </div>
                          <p className="text-gray-400 text-sm line-through">
                            {item.price}
                          </p>
                          <p className="text-basic-orange ">
                            {item.discountPrice}
                          </p>
                        </div>
                        <Link to={item.path}>
                          <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                            Beli
                          </div>
                        </Link>
                      </div>
                    ))}
                    {/* End Items  */}
                  </div>

                  {/* End of relate product segment */}
                </div>
                {/* Flash Sale End */}
              </div>
            </div>
          </Container>
        </div>
      </LayoutHomepage>
    </>
  );
};

export default FLashDealDetail;
